import { Component, effect, inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { SearchSettings } from 'app/back-office/shared/models/common/search-settings.model';
import { ShopContextStore } from 'app/shared/state/shop-context.store';
import { FilterMapper } from 'app/back-office/shared/utilities/filter-mapper';
import { InternalFilterGroup, FilterItem } from 'app/shared/models/filter-group.models';
import { UtilityFunctions } from 'app/shared/utilities/functions.models';
import { SearchBarService } from '../../service/search-bar.service';

@Component({
    selector: 'app-channel-filter',
    templateUrl: './channel-filter.component.html',
    styleUrls: ['./channel-filter.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChannelFilterComponent {
  @Input() filter: InternalFilterGroup;

  loaderId = UtilityFunctions.newGuid();

  searchSettings: SearchSettings = {
    placeholder: 'Search channel...',
    inputId: UtilityFunctions.newGuid(),
    showFilters: false,
  };

  totalCount = 0;
  searchValue = '';
  cacheFilterData: FilterItem[];
  dataToView: FilterItem[] = [];

  private _shopContext = inject(ShopContextStore);

  constructor(
    private searchBarService: SearchBarService,
  ) {
    // Era un subscribe su activatedChannels in ngOnInit: stessa logica, ora al flush.
    effect(() => {
      const res = this._shopContext.activatedChannels();
      this.cacheFilterData = [new FilterItem({ text: 'STATUS.ALL', value: null }), ...res.map(el => FilterMapper.ChannelFilter(el))];
      this.totalCount = res.length;
      this.setDataToView(0);
    });
  }


  onSearch(search: string) {
    this.searchValue = search;
    this.setDataToView(0);
  }

  setDataToView(startSlice: number) {
    const dataToSlice = this.cacheFilterData.filter(element => {
      let isMatch = true;
      if (this.searchValue) {
        const search = this.searchValue.toLowerCase();
        isMatch = element.text?.toLowerCase().indexOf(search) >= 0;
      }
      // More filters
      return isMatch;
    });
    if (this.filter.withPagination) {
      const dataToView = dataToSlice.slice(startSlice, startSlice + 10);
      this.dataToView = dataToView;
    } else {
      this.dataToView = dataToSlice;
    }
  }

  getNextData(skipCount: number) {
    if (this.totalCount > skipCount) {
      this.setDataToView(skipCount);
    }
  }

  onChangeFilter(channelId: number) {
    this.searchBarService.setCurrentChannelFilter(channelId);
  }

}
